<template>
  <div class="add-feedback-photo">
    <div class="addShopPhoto" v-if="!imagePreview">
      <label class="upload-file">
        <CameraIcon />
          <input
            type="file"
            id="file"
            ref="myFiles"
            accept="image/*"
            @change="uploadPhoto"
            multiple
          />
      </label>
    </div>
    <div class="addShopPhoto" v-if="imagePreview">
        
         <label class="file">
            <img :src="imagePreview" :alt="imagePreview" />
            <input
                type="file"
                id="file1"
                ref="myFiles"
                accept="image/*"
                @change="uploadPhoto"
                multiple
            />
      </label>
      <!-- <ul>
        <li v-for="(image,index) in feedbackImagePreview" :key="index">
          <img :src="image" v-if="image" :alt="image" />
          <span class="clear-pic" @click="cutPic(index)">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
              <path
                fill="#727272"
                d="M14.513 2.487c-3.315-3.316-8.71-3.316-12.026 0-3.316 3.316-3.316 8.71 0 12.026 3.315 3.316 8.71 3.316 12.026 0 3.316-3.316 3.316-8.71 0-12.026zm-2.66 9.366a.654.654 0 01-.924 0L8.5 9.425l-2.544 2.544a.654.654 0 11-.925-.925L7.575 8.5 5.147 6.07a.654.654 0 11.925-.925L8.5 7.575l2.313-2.313a.654.654 0 11.925.925L9.425 8.5l2.429 2.428a.654.654 0 010 .925z"
              />
            </svg>
          </span>
        </li>
      </ul> -->
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import constant from "../../utils/constant";
import { getBase64Url } from "../../utils/helper";
import CameraIcon from "@/components/Icons/CameraIcon"

export default {
  props: {
    previousImages: {
      type: Array
    }
  },

components : {
    CameraIcon
},
  data() {
    return {
      uploadShopPhoto: "Click Pic or upload",
      loading: false,
      imagePreview: '',
      feedbackFile: "",
      feedbackImagePreview: null
    };
  },
  methods: {
    cutPic(id) {
      this.feedbackImagePreview.splice(id, 1);
      this.imagePreview.splice(id, 1);
      this.$emit("uploadImageList", this.imagePreview);
    },
    async uploadPhoto(file) {
      const image = file.target.files[0];
      if (!image.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      getBase64Url(image).then(data => {
        this.imagePreview = data;
      });
      const formData = new FormData();
      this.loading = true;
      formData.append("image", image, image.name);
      formData.append("isResizeRequired", true);
      await axios
        .post(constant.FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.feedbackFile = data.data.mediaVariantDTOs[1].url;
          this.loading = false;
          this.$emit("uploadImageList", this.feedbackFile);
        })
        .catch(err => {
          console.log("FAILURE", err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.loader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #e5dcdc36;
  z-index: 9;
}
.loader p {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -45%);
  font-weight: 600;
  padding: 5px;
  background: #000000bd;
  color: #fff;
  border-radius: 10px;
}
.addShopPhoto {
    overflow: hidden;
    border-radius: 50%;
    border: 1px dashed #dddddd;
    background-color: #EBEBEB;
    padding: 8px 15px;
    text-align: center;
    width: 110px;
    height: 110px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  .upload-file {
  color: #505050;
  font-size: 0.875em;
  line-height: 1.5;
  width: 40px;
    height: 40px;
    
}
img{
        max-width: 100%;
    max-height: 100%;
}
svg {
  display: block;
  margin: 0 auto 8px;
      width: 100%;
    height: 100%;
    path{
            fill: white;
    }
}
input[type="file"] {
  display: none;
}
}
.upload_photo {
  display: block;
  border: 1px solid green;
  width: fit-content;
  padding: 8px 25px;
  border-radius: 5px;
  color: green;
  margin: 8px auto 0;
}
.image-preview {
  width: 100%;
}
.image-preview ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.image-preview li {
  width: 20%;
  line-height: 0;
  text-align: center;
  height: 65px;
  border: 1px solid #bfbdbd;
  margin: 10px 15px 20px 0;
  background: #dddddd;
}
.image-preview li:nth-child(4n + 0) {
  margin-right: 0;
}
.image-preview li img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-bottom: 4px;
}
</style>
